import { InjectionToken } from '@angular/core'
import { Action, ActionReducer, createReducer, on } from '@ngrx/store'
import * as PageStateActions from './page-state.actions'
import { initialPageStateState, pageStateAdapter, PageStateState } from './page-state.state'

const pageStateReducer = createReducer(
  initialPageStateState,
  on(PageStateActions.siteStateChanged, (state, action) => {
    if (action.isInitialState) {
      return pageStateAdapter.addOne(action.newState, state)
    }
    return pageStateAdapter.updateOne({ id: action.newState.tokenObj.token, changes: action.newState }, state)
  }),
  on(PageStateActions.siteStateObsolete, (state, action) => {
    return pageStateAdapter.removeOne(action.token, state)
  }),
  on(PageStateActions.siteNavigation, (state, action) => {
    return {
      ...state,
      lastNavStart: action.navStart,
      lastNavEnd: action.navEnd
    }
  }),
  on(PageStateActions.selectEntity, (state, action) => {
    return {
      ...state,
      currentEntity: action.currentEntity
    }
  }),
  on(PageStateActions.unSelectEntity, (state) => {
    return {
      ...state,
      currentEntity: null
    }
  }),
  on(PageStateActions.selectDtoType, (state, action) => {
    return {
      ...state,
      currentDtoType: {
        config: action.currentDtoType,
        headerFields: action.headerFields,
        editableFields: action.editableFields,
        creationFields: action.creationFields,
        excludedPanels: action.excludedPanels
        // refreshTrigger: action.refreshTrigger
      }
    }
  }),
  on(PageStateActions.unSelectDtoType, (state) => {
    return {
      ...state,
      currentDtoType: {
        config: null,
        headerFields: null,
        editableFields: null,
        creationFields: null,
        excludedPanels: null
        // refreshTrigger: action.refreshTrigger
      }
    }
  })
)

export function reducer(state: PageStateState | undefined, action: Action) {
  return pageStateReducer(state, action)
}

export const PAGE_STATE_PROFILE_REDUCER = new InjectionToken<ActionReducer<PageStateState>>('PageState Reducer')
